module.exports = __webpack_public_path__ + "static/016-ce3989aa07c0ae09adf3eefa28bd3e32.jpg";